/**
 * Header component.
 * @module components/theme/Header/Header
 */

import { useEffect, useState } from 'react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import Navigation from '@plone/volto/components/theme/Navigation/Navigation';
import SearchWidget from '@plone/volto/components/theme/SearchWidget/SearchWidget';
import SlotRenderer from '@plone/volto/components/theme/SlotRenderer/SlotRenderer';
import BodyClass from '@plone/volto/helpers/BodyClass/BodyClass';
import cx from 'classnames';
import { getSiteProperties } from 'govbr.frontend.policy/actions/site_properties/site_properties';
import { HtmlHeader } from 'govbr.frontend.policy/components';
import BarraGovbr from 'govbr.frontend.policy/components/BarraGovbr';
import messages from 'govbr.frontend.policy/messages/header';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect, useDispatch, useSelector } from 'react-redux';
import { compose } from 'redux';

import styles from './Header.module.less';

const Header = (props) => {
  // console.log(props);

  const { intl } = props;

  const [menuActive, setMenuActive] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getSiteProperties());
  }, [dispatch]);

  const stickyOffset = 63;
  const [sticky, setSticky] = useState(false);
  useEffect(() => {
    const toggleSticky = () => {
      const hasToolbar =
        document.body.classList.contains('has-toolbar') ||
        document.body.classList.contains('has-toolbar-collapsed');
      const enableSticky =
        !hasToolbar || (hasToolbar && document.body.clientWidth >= 768);
      setSticky(window.pageYOffset > stickyOffset && enableSticky);
    };

    document.addEventListener('scroll', toggleSticky);
    window.addEventListener('resize', toggleSticky);

    return () => {
      document.removeEventListener('scroll', toggleSticky);
      window.removeEventListener('resize', toggleSticky);
    };
  });

  const site_properties = useSelector((state) => state.site_properties.data);
  const content = useSelector((state) => state.content?.data);

  const classes = cx('br-header large d-block pt-0', {
    [styles.sticky]: sticky,
  });

  return (
    <>
      <div id="search-modal" />
      <HtmlHeader />
      {!!menuActive && <BodyClass className="navigation-menu-active" />}
      {!!sticky && <BodyClass className="header-sticky" />}
      <header className={classes}>
        <div className="ui container">
          <BarraGovbr />
          {/* <div className="header-top">
            <HeaderLogo
              organ={site_properties.organ}
              organUrl={site_properties.organ_url}
            />
            <div className="header-actions">
              <HeaderLinks />
              <Acessogov />
            </div>
          </div> */}
          <div className="header-bottom">
            <div className="header-menu align-items-center">
              <div className="header-menu-trigger">
                <button
                  className="br-button small circle"
                  type="button"
                  title={intl.formatMessage(messages.openNavigationMenu)}
                  aria-label={intl.formatMessage(messages.openNavigationMenu)}
                  data-toggle="menu"
                  data-target="#main-navigation"
                  id="navigation"
                  onClick={() => setMenuActive(!menuActive)}
                >
                  <i className="fas fa-bars" aria-hidden="true"></i>
                </button>
              </div>
              <div className={cx('header-info', styles['header-info'])}>
                <UniversalLink
                  href="/"
                  className={cx('header-title', styles.title)}
                >
                  {site_properties.site_title}
                </UniversalLink>
              </div>
            </div>
            <SearchWidget />
          </div>
        </div>
      </header>

      <Navigation
        active={menuActive}
        pathname={props.pathname}
        onClose={() => {
          setMenuActive(!menuActive);
        }}
        token={props.token}
      />

      <SlotRenderer name="belowHeader" content={content} />
    </>
  );
};

Header.propTypes = {
  token: PropTypes.string,
  pathname: PropTypes.string.isRequired,
};

Header.defaultProps = {
  token: null,
};

export default compose(
  injectIntl,
  connect((state) => ({
    token: state.userSession.token,
  })),
)(Header);
